import globalStyles from "../../assets/styles/global.module.scss";

export const MENU_ITEM_VARIANT_CLASS = {
    default: globalStyles.defaultVariantMenuItem,
    primary: globalStyles.primaryVariantMenuItem,
    grey: globalStyles.greyVariantMenuItem
}